import { Inject, Injectable } from '@angular/core';
import { IUnitOfWork } from 'src/app/common/contracts/unit-of-work/unit-of-work';
import { IUnitOfWorkFactory } from 'src/app/common/contracts/unit-of-work/unit-of-work-factory';
import { PostalCodeDB } from 'src/app/common/repository/databases';
import { UnitOfWorkFactory } from 'src/app/common/unit-of-work/unit-of-work-factory';
import { PostalCodeDto } from 'src/app/shared/models/institution/postal-code-dto.model';

import { WorkItem } from '../work-item';

@Injectable({ providedIn: 'root' })
export class PostalCodeWorkItem extends WorkItem<PostalCodeDto> {
  unitOfWork: IUnitOfWork;

  constructor(@Inject(UnitOfWorkFactory) unitOfWorkFactory: IUnitOfWorkFactory) {
    super(unitOfWorkFactory);
    this._deletable = false;
  }
  get name(): string {
    return 'PostalCodeWorkItem';
  }
  get database(): string {
    return PostalCodeDB;
  }
}
